let shopconfig = [
    {
        path: '/shopconfig/fareTemplate',
        name: 'list',
        component: () => import('@/views/shopconfig/fareTemplate/list.vue'),
        meta: {keepAlive: true, parentPath: 'shopconfig'},
    },
    {
        path: '/shopconfig/fareTemplate/edit',
        name: 'edit',
        component: () => import('@/views/shopconfig/fareTemplate/edit.vue'),
        meta: {keepAlive: true, parentPath: 'shopconfig'},
    },
    {
        path: '/shopconfig/shopMenu',
        name: 'shopMenu',
        component: () => import('@/views/shopconfig/shopMenu.vue'),
        meta: {keepAlive: true, parentPath: 'shopconfig'},
    }

    
    
]
export default shopconfig


// WEBPACK FOOTER //
// ./src/router/shopconfig.js